import { Outlet } from "react-router-dom";


export default function DeviceManagementScreen () {

    return(
        <>
            <Outlet/>
        </>
    )
}